import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaServer,
  FaWhatsapp,
  FaCogs,
  FaMobileAlt,
  FaTools,
  FaRobot,
  FaUserFriends,
  FaGlobe,
} from 'react-icons/fa';

export default function Home({ darkMode = false, language = 'en' }) {
  const handleServiceClick = (idx) => {
    navigate("/services", { state: { scrollTo: `service-${idx + 1}` } }); // Add 1 to idx
  };
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hoveredService, setHoveredService] = useState(null);
  const [contentSize, setContentSize] = useState(window.innerWidth > 780 ? 'large' : 'small');

  const navigate = useNavigate();

  const images = [
    '/images/home/VPS.jpg',
    '/images/services/WhatsApp.png',
    '/images/services/ERPConsulting.png',
    '/images/services/AIAutomation.jpg',
    '/images/home/Mobile.png',
    '/images/home/MobileApp3.png',
    '/images/home/Hardware.jpg',
    '/images/services/ERPSolution.png',
  ];

  const translations = {
    en: {
      title: 'INFYNIX SOLUTION',
      subtitle: 'Empower your business with our cutting-edge IT solutions and services',
      readMore: 'READ MORE',
      services: [
        { icon: <FaServer size={contentSize==='large'?30:14} />, label: 'VPS Servers & Cloud Services' },
        { icon: <FaWhatsapp size={contentSize==='large'?30:14} />, label: 'WhatsApp Chatbot & Communication' },
        { icon: <FaUserFriends size={contentSize==='large'?30:14} />, label: 'ERP Implementation & Consulting' },
        { icon: <FaRobot size={contentSize==='large'?30:14} />, label: 'AI Automation' },
        { icon: <FaGlobe size={contentSize==='large'?30:14}/>, label: 'Website Development' },
        { icon: <FaMobileAlt size={contentSize==='large'?30:14} />, label: 'Mobile App Development & Customization' },
        { icon: <FaTools size={contentSize==='large'?30:14} />, label: 'Hardware Services' },
        { icon: <FaCogs size={contentSize==='large'?30:14} />, label: 'Custom ERP Solutions' },
      ],
    },
    ar: {
      title: 'INFYNIX SOLUTION',
      subtitle: 'قم بتمكين أعمالك بحلولنا وخدماتنا التقنية المتطورة',
      readMore: 'اقرأ المزيد',
      services: [
        { icon: <FaServer size={contentSize==='large'?30:14} />, label: 'خوادم VPS وخدمات السحابة' },
        { icon: <FaWhatsapp size={contentSize==='large'?30:14} />, label: 'روبوت واتساب والتواصل' },
        { icon: <FaUserFriends size={contentSize==='large'?30:14} />, label: 'تنفيذ واستشارات ERP' },
        { icon: <FaRobot size={contentSize==='large'?30:14} />, label: 'أتمتة الذكاء الاصطناعي' },
        { icon: <FaGlobe size={contentSize==='large'?30:14} />, label: 'تطوير المواقع' },
        { icon: <FaMobileAlt size={contentSize==='large'?30:14} />, label: 'تطوير تطبيقات الجوال والتخصيص' },
        { icon: <FaTools size={contentSize==='large'?30:14} />, label: 'خدمات الأجهزة' },
        { icon: <FaCogs size={contentSize==='large'?30:14} />, label: 'حلول ERP مخصصة' },
      ],
    },
  };

  const currentLang = translations[language] || translations.en;

  // Auto-change background + highlight service
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
      setHoveredService((prev) =>
        prev === null || prev === images.length - 1 ? 0 : prev + 1
      );
    }, 5000);
    setHoveredService(0);
    return () => clearInterval(interval);
  }, [images.length]);

  const handleReadMore = () => {
    const whyUsSection = document.getElementById('whyus');
    if (whyUsSection) whyUsSection.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className="hero-header"
      style={{
        backgroundImage: `url(${images[currentIndex]})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.72)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '0px',
          color: '#fff',
        }}
      >
        {/* Logo */}
        <img
          src="/images/services/2logo.png"
          alt="Logo"
          style={{ width: '200px', marginBottom: contentSize==='large'?'10px':'0px' }}
        />

        {/* Title */}
        <h1
          style={{
            fontSize: contentSize==='large'?'36px':'20px',
            margin: contentSize==='large'?'0 0 8px':'0 0 0px',
            fontWeight: 700,
            textTransform: 'uppercase',
            fontFamily: "'Poppins', sans-serif",
          }}
        >
          {currentLang.title}
        </h1>

        {/* Subtitle */}
        <h3
          style={{
            fontSize: language === 'ar' ? '22px' : '14px',
            fontWeight: 400,
            marginBottom: contentSize==='large'?'16px':'4px',
            color: '#e0e0e0',
            maxWidth: '85%',
            lineHeight:contentSize==='large'? '1.4':'0.8',
            fontFamily: language === 'ar' ? "'Amiri', sans-serif" : "'Inter', sans-serif",

          }}
        >
          {currentLang.subtitle}
        </h3>

        {/* Services 8 × 1 */}
        <div
          className="services-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(8, 1fr)',
            gap: contentSize==='large'?'12px 16px':"2px 3px",
            marginBottom: contentSize==='large'?'12px':0,
            width: '100%',
            maxWidth: '960px',
            fontFamily: language === 'ar' ? "'Amiri', sans-serif" : "'Inter', sans-serif",

          }}
        >
          {currentLang.services.map((item, idx) => (
            <div
              key={idx}
              onClick={()=>handleServiceClick(idx)}
              style={{
                cursor:'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                transition: 'transform 0.3s ease, opacity 0.3s ease',
                transform: hoveredService === idx ? 'scale(1.05)' : 'scale(1)',
                opacity: hoveredService === null || hoveredService === idx ? 1 : 0.75,
              }}
              onMouseEnter={() => setHoveredService(idx)}
              onMouseLeave={() => setHoveredService(currentIndex)}
            >
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  background:
                    hoveredService === idx
                      ? 'linear-gradient(to right, #0056b3, #003d80)'
                      : 'linear-gradient(to right, #007BFF, #0056b3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                }}
              >
                {item.icon}
              </div>
              <p
                style={{
                  marginTop: contentSize==='large'?'4px':'0px',
                  fontSize: language === 'ar' ? '12px' : contentSize==='large'?'14px':'9px',
                  textAlign: 'center',
                  lineHeight: '1.2',
                }}
              >
                {item.label}
              </p>
            </div>
          ))}
        </div>

        {/* Button */}
        <button
          onClick={handleReadMore}
          style={{
            background: 'linear-gradient(to right, #007BFF, #0056b3)',
            border: 'none',
            color: '#fff',
            padding: '8px 20px',
            borderRadius: '9999px',
            fontSize: '12px',
            cursor: 'pointer',
            fontWeight: 400,
          }}
        >
          {currentLang.readMore}
        </button>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400&family=Poppins:wght@400;500;600&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Amiri:wght@400&display=swap');

        @media (max-width: 768px) {
          .hero-header {
            height: auto !important;
            aspect-ratio: 16 / 9;
          }
          img[alt="Logo"] { width: 100px !important; }
          h1 { font-size: 18px !important; }
          h3 { font-size: 10px !important; margin-bottom: 10px !important; }
          .services-grid { 
            max-width: 300px !important; 
            gap: 8px 8px !important; 
            grid-template-columns: repeat(4, 1fr) !important;
            grid-template-rows: repeat(2, auto) !important;
          }
          .services-grid div div { width: 28px !important; height: 28px !important; }
          .services-grid div div svg { font-size: 14px !important; }
          .services-grid p { font-size: 7px !important; }
          button { padding: 4px 10px !important; font-size: 9px !important; }
        }

        @media (max-width: 480px) {
          img[alt="Logo"] { width: 80px !important; }
          h1 { font-size: 16px !important; }
          h3 { font-size: 9px !important; }
          .services-grid { max-width: 260px !important; }
          .services-grid div div { width: 24px !important; height: 24px !important; }
          .services-grid div div svg { font-size: 12px !important; }
          .services-grid p { font-size: 6px !important; }
          button { padding: 3px 8px !important; font-size: 8px !important; }
        }
      `}</style>
    </header>
  );
}